import { Table, TableColumnsType } from 'antd';
import moment from 'moment';
import React, { useRef } from 'react';
import { TableData } from '../../../pages/dashBoardPage/interface';

interface DataType {
  key: React.Key;
  bookingId: string;
  bookingTime: string;
  customerName: string;
  activityName: string;
  email: string;
  status: string;
  price: string;
}
const filters = [
  { key: 'All', value: '' },
  { key: 'Confirmed', value: 'CONFIRMED' },
  { key: 'Pending', value: 'PENDING' },
  { key: 'Canceled', value: 'CANCELED' },
];

const DashboardTable = ({
  tableData,
  isLoading,
  filter,
  setFilter,
  openFilter,
  setOpenFilter,
  setPage,
}: {
  tableData: TableData;
  isLoading: boolean;
  filter: string;
  setFilter: React.Dispatch<React.SetStateAction<string>>;
  openFilter: boolean;
  setOpenFilter: React.Dispatch<React.SetStateAction<boolean>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const searchInputRef = useRef(null);
  const handleClickFilter = (value: string) => {
    setPage(0);
    setFilter(value);
    setOpenFilter(false);
  };

  const columns: TableColumnsType<DataType> = [
    {
      title: 'Booking ID',
      dataIndex: 'bookingId',
      render: (_, record) => (
        <div className="first-col-item">
          <h6>{record.bookingId}</h6>
          <p className="td-date">{record.bookingTime}</p>
        </div>
      ),
      fixed: 'left',
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
    },
    {
      title: 'Activity Name',
      dataIndex: 'activityName',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            position: 'relative',
          }}
        >
          <img
            src={
              filter
                ? '/assets/table-filter-active.svg'
                : '/assets/table-filter.svg'
            }
            alt="icon"
            width={16}
            height={16}
            onClick={() => setOpenFilter(!openFilter)}
            className="cursor-pointer"
          />
          <span>Status</span>
        </div>
      ),
      filterDropdownVisible: openFilter,
      onFilterDropdownVisibleChange: setOpenFilter,
      filterIcon: () => <span style={{ display: 'none' }} />,
      filterDropdown: ({ confirm }) => (
        <div className="table-status-filter">
          {filters.map((item) => (
            <div
              style={{
                background: filter === item.value ? '#E2E9FD' : 'white',
              }}
              onClick={() => {
                handleClickFilter(item.value);
                confirm();
              }}
              className={`table-filter-item ${item.value}`}
              key={item.key}
            >
              {item.key}
            </div>
          ))}
        </div>
      ),
      dataIndex: 'status',
      render: (text, record) => (
        <div className={`table-td-status ${record.status}`}>
          <div className={`dot ${record.status}`}></div>
          {record.status}
        </div>
      ),
    },
    {
      title: 'Price',
      dataIndex: 'price',
    },
  ];
  const dataSource = tableData?.payloads?.content?.map<DataType>((data, i) => ({
    key: i,
    bookingId: data?.bookingId,
    bookingTime: moment(data?.bookingTimestamp).format('DD/MM/YYYY - HH:mm A'),
    customerName: data?.customerName,
    activityName: data?.activityName,
    email: data?.customerEmail,
    status: data?.bookingStatus,
    price: `${data?.currency} ${data?.totalPrice?.toFixed(2)}`,
  }));

  return (
    <Table<DataType>
      //   className={styles.customTable}
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      loading={isLoading}
      scroll={{ x: 1100 }}
    />
  );
};

export default DashboardTable;
